import { navigationMenuLinks } from './navigation-links.js';
import { getMenuLinkAttributes } from './get-menu-link-attributes.js';

function generateMobileMenuContent(menuContent) {
    // Find the navigation container
    const navigationDiv = menuContent.querySelector('.navigation');
    if (!navigationDiv) return;

    // Generate the HTML
    let html = '<ul class="main-items">';

    navigationMenuLinks.forEach((submenu) => {
        html += `<li>`;
        html += `<button aria-controls="sub-items__${submenu.id}" type="button">${submenu.text}</button>`;
        html += `<div aria-expanded="false" id="sub-items__${submenu.id}" class="sub-items-wrapper">`;
        html += `<ul class="sub-items sub-items--js">`;

        const externalThirdLevelLinks = [];

        submenu.links.forEach((linkObj) => {
            const hasSubItems = linkObj.links && linkObj.links.length > 0 && false; // Disable third level items
            const externalSubItems = linkObj?.links?.filter((link) => link.newTab);
            externalThirdLevelLinks.push(...externalSubItems);

            if (externalSubItems?.some((item) => item.link === linkObj.link)) {
                return;
            }

            html += `<li class="main-menu-nav-item">`;

            const primaryLinkAttrs = hasSubItems ? '' : getMenuLinkAttributes(linkObj);

            html += `<div class="main-menu-nav-item-inner">`;

            html += `<a ${hasSubItems ? 'role="button"' : primaryLinkAttrs} class="main-menu-nav-link main-menu-nav-link--primary sub-toggle--js">${linkObj.text}</a>`;

            if (hasSubItems) {
                const subId = `sub-sub-items__${submenu.id}_${linkObj.text.replace(/\s+/g, '-')}`;
                html += `</div>`;

                html += `<div aria-expanded="false" id="${subId}" class="sub-sub-items-wrapper">`;
                html += `<div class="sub-sub-items-inner">`;
                html += `<ul class="main-menu-nav-sublist">`;

                linkObj.links.forEach((subLinkObj) => {
                    html += `<li class="main-menu-nav-subitem">`;
                    const secondaryLinkAttrs = getMenuLinkAttributes(subLinkObj);
                    html += `<a ${secondaryLinkAttrs} class="main-menu-nav-link main-menu-nav-link--secondary">${subLinkObj.text}</a>`;
                    html += `</li>`;
                });

                html += `</ul>`;
                html += `</div>`;
                html += `</div>`;
            } else {
                html += `</div>`;
            }

            html += `</li>`;
        });

        externalThirdLevelLinks.forEach((linkObj) => {
            html += `<li class="main-menu-nav-item">`;
            const primaryLinkAttrs = getMenuLinkAttributes(linkObj);
            html += `<a ${primaryLinkAttrs} class="main-menu-nav-link main-menu-nav-link--primary">${linkObj.text}</a>`;
            html += `</li>`;
        });

        html += `</ul>`;
        html += `</div>`;
        html += `</li>`;
    });

    navigationDiv.innerHTML = html;
}

export function mobileMenu() {
    const menuContent = document.querySelector('.mobile-menu--js');
    if (!!menuContent === false) return;

    generateMobileMenuContent(menuContent);

    const buttons = document.querySelectorAll('.menu-button--js');
    buttons.forEach((button) => {
        button.addEventListener('click', openMenu);
    });
    const closeMenuButtons = document.querySelectorAll('.close-menu--js');
    closeMenuButtons.forEach((button) => {
        button.addEventListener('click', closeMenu);
    });

    function openMenu() {
        Swal.fire({
            customClass: {
                container: 'mobile-menu-swal-container',
            },
            html: menuContent.outerHTML,
            showClass: {
                popup: 'animationSlideUp',
            },
            hideClass: {
                popup: 'animationSlideDown',
            },
            showConfirmButton: false,
            didOpen: (popup) => {
                setupSwipeToClose(popup);
                setupSubItemsToggle(popup);
            },
        });
    }
    function closeMenu() {
        Swal.close();
    }

    function setupSwipeToClose(popupElement) {
        const dragContainer = popupElement.querySelector('.drag-container');

        if (!dragContainer) return;

        let startY = 0;
        const SWIPE_THRESHOLD = 80;

        dragContainer.addEventListener(
            'touchstart',
            (e) => {
                startY = e.touches[0].clientY;
                e.stopPropagation();
            },
            { passive: true }
        );

        dragContainer.addEventListener(
            'touchend',
            (e) => {
                const endY = e.changedTouches[0].clientY;
                const deltaY = startY - endY; // Positive for swipe up, negative for swipe down

                if (Math.abs(deltaY) > SWIPE_THRESHOLD) {
                    closeMenu();
                }
                e.stopPropagation();
            },
            { passive: true }
        );

        dragContainer.addEventListener('click', closeMenu);

        popupElement.addEventListener('click', (e) => {
            const link = e.target.closest('a[href^="#"]');
            if (!link) return;

            requestAnimationFrame(() => Swal.close());
        });
    }

    function setupSubItemsToggle(popupElement) {
        const firstLevelBtns = popupElement.querySelectorAll('button[aria-controls]');
        // const subLevelBtns = popupElement.querySelectorAll('.sub-toggle--js');
        const subLevelBtns = []; // Disable third level items

        firstLevelBtns.forEach((btn) => {
            const subItemsWrapper = btn.parentElement.querySelector('.sub-items-wrapper');

            btn.addEventListener('click', () => {
                const isCurrentlyExpanded = subItemsWrapper.ariaExpanded === 'true';

                // Close all other sub-items
                firstLevelBtns.forEach((otherBtn) => {
                    if (otherBtn !== btn) {
                        const otherWrapper = otherBtn.parentElement.querySelector('.sub-items-wrapper');
                        if (otherWrapper) {
                            otherWrapper.ariaExpanded = 'false';
                        }
                    }
                });

                // Close all other sub-items
                subLevelBtns.forEach((otherBtn) => {
                    if (otherBtn !== btn) {
                        const otherWrapper = otherBtn.parentElement.parentElement.querySelector('.sub-sub-items-wrapper');
                        if (otherWrapper) {
                            otherWrapper.ariaExpanded = 'false';
                        }
                    }
                });

                // Toggle current sub-item
                subItemsWrapper.ariaExpanded = isCurrentlyExpanded ? 'false' : 'true';
            });
        });

        subLevelBtns.forEach((btn) => {
            const subItemsWrapper = btn.parentElement.parentElement.querySelector('.sub-sub-items-wrapper');
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const isCurrentlyExpanded = subItemsWrapper.ariaExpanded === 'true';
                subItemsWrapper.ariaExpanded = isCurrentlyExpanded ? 'false' : 'true';

                // Close all other sub-items
                subLevelBtns.forEach((otherBtn) => {
                    if (otherBtn !== btn) {
                        const otherWrapper = otherBtn.parentElement.parentElement.querySelector('.sub-sub-items-wrapper');
                        if (otherWrapper) {
                            otherWrapper.ariaExpanded = 'false';
                        }
                    }
                });
            });
        });
    }
}
